var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegrasprueba1Cropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1926.98 1803.14"
    },
    xmlSpace: "preserve",
    viewBox: "536.59 586.34 135.75 125.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666.45,615.04v-28.7c0,0-20.05,4.36-36.04,23c-0.13,0.15-0.26,0.3-0.38,0.45    c-10.99,12.92-16.9,29.38-16.9,46.34v48.29c0,4.23,3.43,7.67,7.67,7.67h43.87c4.23,0,7.67-3.43,7.67-7.67v-40.93    c0-4.23-3.43-7.67-7.67-7.67H641.5C641.5,655.81,637.91,630.53,666.45,615.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M589.91,615.04v-28.7c0,0-20.05,4.36-36.04,23c-0.13,0.15-0.26,0.3-0.38,0.45    c-10.99,12.92-16.9,29.38-16.9,46.34v48.29c0,4.23,3.43,7.67,7.67,7.67h43.87c4.23,0,7.67-3.43,7.67-7.67v-40.93    c0-4.23-3.43-7.67-7.67-7.67h-23.16C564.96,655.81,561.37,630.53,589.91,615.04z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegrasprueba1Cropped);
export default __webpack_public_path__ + "static/media/Negrasprueba1-cropped.9e6f90c169c2ecc98f03a2f68f9e1a43.svg";
export { ForwardRef as ReactComponent };